import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEConstant } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { ConstantItem } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ConstantItem';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType, EnumDataTypeMD } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointConstantShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointConstantShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_Constant.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(constantShape: NodeShape, constant: BEConstant, isFromJSON: boolean) {
    if (constant) {
      MDExtendService.setElementListSequence(constant.items, false);
    }
    this.setBaseMD(constantShape, this.createModel(constant, !constantShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_CONSTANT;
  }

  get constant(): BEConstant {
    return this.element() as BEConstant;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加项
      case 'shape:addConstantItem':
        element = this.addConstantItem();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType === MDAConstant.Link.ADD_COMPOSITION || linkType === MDAConstant.Link.ADD_AGGREGATION || linkType === MDAConstant.Link.ADD_GENERALIZATION ||
        linkType === MDAConstant.Link.ADD_ASSOCIATION || linkType === MDAConstant.Link.ADD_DEPENDENCY || linkType === MDAConstant.Link.ADD_IMPLEMENT) {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof ConstantItem) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${EnumDataTypeMD.getItemByValue(element.dataType).name}`;
      } else {
        title = `${element.displayName}:${EnumDataTypeMD.getItemByValue(element.dataType).name}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addConstantItem(): ConstantItem {
    const constantItem = MDRepository.createConstantItem(this.constant);
    MDExtendService.setElementListSequence(this.constant.items, true);
    this.model().compartments[0].push(constantItem);
    return constantItem;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.constant.items.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.constant.items.splice(this.constant.items.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(constant: BEConstant, isCollapse = false): ShapeModel {
    const model = new ShapeModel(constant, isCollapse);
    model.addCompartment(constant.items.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointConstantShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEConstant();
    newElement.copyFrom(this.constant, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.constants.push(newElement);
    }

    this.constant.items.forEach(item => {
      const constantItem = new ConstantItem();
      constantItem.copyFrom(item, false);
      MDExtendService.setCreateInfo(constantItem);
      constantItem.constant_ID = newElement.id;
      newElement.items.push(constantItem);
      elements.push(constantItem);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): ConstantItem | null {
    let newElement: ConstantItem | null = null;
    if (element instanceof ConstantItem) {
      newElement = new ConstantItem();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.constant_ID = this.constant.id;
      this.constant.items.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. 必须包含至少一项
   * 2. 常量项
   *    - 必须填写名称
   *    - 必须填写显示名称
   *    - 必须填写常量值
   *    - 不能存在同名项
   *    - 不能设置为引用类型
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.constant.designId;
    MDValidation.validateBaseElement(this.constant, this.constant.designId, true, errors);
    if (this.constant.items.length === 0) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `常量 [${this.constant.displayName}] 必须包含至少一项`));
    } else {
      this.constant.items.forEach(element => {
        MDValidation.validateBaseElement(element, containerDesignId, true, errors);
        if (!ValidateHelper.IsNotNullOrEmpty(element.itemValue)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `常量 [${this.constant.displayName}] 的项 [${element.displayName}] 必须填写常量值`));
        }
        if (this.constant.items.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `常量 [${this.constant.displayName}] 不能存在同名项 [${element.name}]`));
        }
        if (element.dataType === EnumDataType.Reference) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `常量 [${this.constant.displayName}] 的项 [${element.displayName}] 不能设置为引用类型`));
        }
      });
    }
    return errors;
  }
}
